export function languageName(languageCode: string, displayLanguageCode: string): string {
  return new Intl.DisplayNames([baseSubtag(displayLanguageCode)], {type: "language"})
    .of(baseSubtag(languageCode))!;
}

function baseSubtag(languageCode: string): string {
  return languageCode.split("-")[0];
}
